import { Box, HStack, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PrompTestingAnswerTopbar from "./PrompTestingAnswerTopbar";
import SkeletonChat from "../../../components/loader/skeletonLoader/SkeletonChat";
import { MarkDownConerter } from "../../../components/MarkDownConverter/MarkDownConerter.jsx";
import { commonStyle } from "../../../styles/commonStyle.js";
function PromptTestingAnswer({setFormData}) {
  const [answerData, setAnswerData] = useState("");

  const proptSaveData = useSelector(
    (state) => state.promptTesting.propmtSaveData
  );

  const promptTestAnswer = useSelector(
    (state) => state?.promptTesting?.promptTestingResponce
  );

  const proptTestingLoading = useSelector(
    (state) => state?.promptTesting?.proptTestingLoading
  );


  useEffect(() => {
    setAnswerData(promptTestAnswer?.answer);
  }, [promptTestAnswer]);

  useEffect(() => {
    setAnswerData(proptSaveData?.llm_response);
  }, [proptSaveData]);

  

  return (
    <Box w={"42%"} h={"100%"}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        borderBottom={"1px solid #E4E4E7"}
        p={2}
        h={"50px"}
      >
        <HStack>
          <Text fontWeight={"bold"}>Completions</Text>
          <Text
            borderRadius={"md"}
            bg={"#EFEFF1"}
            border={"1px solid #EFEFF1"}
            fontSize={"12px"}
            color={"black"}
          >
            #{promptTestAnswer?.chat_completion?.prompt_tokens}
          </Text>
          <Text
            borderRadius={"md"}
            bg={"#EFEFF1"}
            border={"1px solid #EFEFF1"}
            fontSize={"12px"}
            color={"black"}
          >
            ${promptTestAnswer?.chat_completion?.total_tokens}
          </Text>
        </HStack>
        <PrompTestingAnswerTopbar setFormData={setFormData} />
      </Box>

      <Box p={2} overflowY="auto" sx={{ ...commonStyle.sx,scrollBehavior: "smooth", }} h={"90%"}>
        {proptTestingLoading ? (
          <SkeletonChat />
        ) : answerData ? (
          <Text><MarkDownConerter paragraph={answerData} /></Text>
        ) : (
          <Text color={"#A2A2AB"}>
            Compose your prompt and click Complete to generate outputs...
          </Text>
        )}

      </Box>
    </Box>
  );
}

export default PromptTestingAnswer;
